import { getIsFilterOptions } from '@/constants/options/is-filter-options';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            'name',
            { key: 'code', trans: 'code.task', defaultOperator: 'like' },
        ],
        type: 'input',
        value: [],
    },
    {
        key: [
            {
                key: 'taskCheckStatus',
                trans: 'taskCheckStatus',
                defaultOperator: '=',
            },
        ],
        type: 'select',
        value: getIsFilterOptions(),
    },
];
